import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import { findPolicy, POLICY_UPDATED } from "../Datas/policyData";
import { PolicyText } from "./PolicyText";
import "../css/privacy.scss";

function AdditionalPolicy() {
  const { policySlug } = useParams();
  const policy = findPolicy(policySlug);

  if (!policy) {
    return <Navigate to="/policies" replace />;
  }

  return (
    <div className="legal-page">
      <Header />
      <main id="MainContent">
        <article id="cms-content" aria-labelledby="policy-title">
          <div>
            <p className="legal-page__eyebrow">averlynxstore policy</p>
            <h1 id="policy-title">{policy.title}</h1>
            <p className="legal-page__updated">
              <strong>Last updated: {POLICY_UPDATED}</strong>
            </p>
            <p className="legal-page__intro">{policy.summary}</p>

            {policy.sections.map((section) => (
              <section key={section.title} className="legal-page__section">
                <h2>{section.title}</h2>
                {section.paragraphs?.map((paragraph) => (
                  <p key={paragraph}>
                    <PolicyText>{paragraph}</PolicyText>
                  </p>
                ))}
                {section.bullets ? (
                  <ul>
                    {section.bullets.map((bullet) => (
                      <li key={bullet}>
                        <PolicyText>{bullet}</PolicyText>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}

            <aside className="legal-page__notice" aria-label="Consumer rights notice">
              This policy is part of the averlynxstore store terms. It does not
              limit any consumer or privacy right that cannot be waived under
              applicable law.
            </aside>

            <p className="legal-page__back">
              <Link to="/policies">View all store policies</Link>
            </p>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default AdditionalPolicy;
